<div class="demo-scroll-container">
    <upp-scrollable [scrollbar]="'y'">
        <div class="demo-content">
            <h2>Input + select</h2>
            <p class="demo-description">
                Type a value freely or pick one from the dropdown when options are available.
            </p>

            <form [formGroup]="form" class="demo-section">
                <ion-list>
                    <ion-item lines="full">
                        <upp-input-select
                            formControlName="device"
                            title="Printer device"
                            placeholder="Device name"
                            [options]="printers"
                            [kiosk]="false"
                            [errornfo]="errorMessages"
                        ></upp-input-select>
                    </ion-item>
                    <ion-item lines="full">
                        <upp-input-select
                            formControlName="free"
                            title="Without options"
                            placeholder="Always free text"
                            [options]="[]"
                            [kiosk]="false"
                        ></upp-input-select>
                    </ion-item>
                </ion-list>

                <p class="result-count">device = {{ form.get('device')?.value || '(empty)' }}</p>

                <div class="demo-actions">
                    <ion-button (click)="clearOptions()">Clear options</ion-button>
                    <ion-button (click)="restoreOptions()">Restore options</ion-button>
                </div>
            </form>
        </div>
    </upp-scrollable>
</div>
